import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { EMPTY, interval } from 'rxjs';
import { catchError, switchMap, tap, take } from 'rxjs/operators';

import { BaseComponent } from '../../_core/components/base.component';
import { AuthService } from '../../_services/auth/auth.service';

@Component({
    selector: 'app-auth-check',
    template: `
        <div style="width:100%;margin-top:60px;text-align:center;align-content: center;">
            <span style="border-left:3px solid #003865; padding-left:1rem; font-size: 1.5rem;">Authorizing...</span>
        </div>
    `,
    styles: [],
    standalone: false
})
export class AuthCheckComponent extends BaseComponent {
    constructor(
        private readonly router: Router,
        private readonly authService: AuthService
    ) {
        super();
    }

    OnInit(): void {
        this.addSubscription(
            // Keep the splash briefly, then allow a valid refresh cookie to restore the session
            // before deciding whether to send the user to login.
            interval(1000)
                .pipe(
                    take(1),
                    // This page already says "Authorizing...", so the session-check overlay stays off. There is
                    // no page to return to, so a restored session goes to the user's home page, as after login.
                    switchMap(() => this.authService.ensureAuthenticated(undefined, { showProgress: false })),
                    tap(isAuthenticated => {
                        if (isAuthenticated) {
                            this.authService.navigateToHome();
                        } else {
                            this.router.navigate(['/login']);
                        }
                    }),
                    catchError(() => EMPTY)
                )
        );
    }
}
